document.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const ffParam = urlParams.get('aud_ff') || window.sessionStorage.getItem('audFF') || 'first';
    document.body.classList.add('ff-' + ffParam);
})